import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Button, TextField } from "@mui/material";
import * as React from "react";

import styled from "@emotion/styled";
import LoadingButton from "@mui/lab/LoadingButton";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import * as yup from "yup";
import { PublicURLImages } from "../config";
import service from "../service/Service";
import passTemplate1 from "../assets/pass-templates/Invite1.jpeg";
import axios from "axios";

const validationSchema = yup.object({
  linkstd_linkedin_username: yup
    .string("Linkedin Url Required")
    .url("Linked in Must Be URL")
    .required("Linked URL Required"),

  email: yup.string().email("Inavlid Email").required("Email is required"),
});

export const StudentProfile = () => {
  const [responsestatus, Setresponsestatus] = React.useState(1);
  const [loadingbtn, Setloadinbtn] = React.useState(false);
  const [newerror, Seterror] = React.useState("");
  const [profilepicture, Setprofilepicture] = React.useState("");
  const [getstuddents, setstudents] = React.useState([]);
  const [username, setusername] = React.useState("");
  const [imagebase, setimagebase] = React.useState("");
  const [imageext, Setimageext] = React.useState("");
  const [isImageChange, setIsImageChange] = React.useState(false);

  const onImageChange = async (event) => {
    setIsImageChange(true);
    let base64 = await convertBase64(event.target.files[0]);
    base64 = base64.split(",")[1];
    setimagebase(base64);
    let photoExt = event.target.files[0].type.split("/")[1];
    Setimageext(photoExt);
    console.log("CHANGE");
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const formik = useFormik({
    initialValues: {
      linkstd_linkedin_username: getstuddents?.std_linkedin_username || "",
      name: getstuddents?.std_name || "",
      std_id: getstuddents?.std_id || "",
      email: getstuddents?.std_email || "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      // console.log(values);

      let obj = Object.assign(
        {
          std_linkedin_username: values.linkstd_linkedin_username,
          email: values.email,
        },
        {
          ext: imageext,
          image: imagebase,
        }
      );

      console.log(obj);

      PostData(obj, resetForm);

      // if (imagebase == "") {
      //   PostData(
      //     {
      //       std_linkedin_username: values.linkstd_linkedin_username,
      //       email: values.email,
      //     },
      //     resetForm
      //   );
      // } else {
      //   PostData(obj, resetForm);
      // }
    },
  });

  const ColorButton = styled(Button)(({ theme }) => ({
    color: "white",
    backgroundColor: "#AB509D",
    "&:hover": {
      backgroundColor: "#AB509D",
    },
  }));
  React.useEffect(() => {
    getdata();
  }, []);

  const getdata = () => {
    // axios
    //   .get(`${BaseURL}studentInfo`, { headers: Bearer })
    //   .then((response) => {
    //     // console.log(response, "student info");
    //     setstudents(response.data.studentInfo);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });

    service
      .get("studentInfo")
      .then((response) => {
        setstudents(response.data.studentInfo);
        console.log(response.data.studentInfo);
      })
      .catch((error) => { });
  };

  const PostData = (latestvalues, resetForm) => {
    Setloadinbtn(true);
    service
      .post(`update-student-profile`, latestvalues)
      .then((responnse) => {
        if (responnse.data.status === 200) {
          Setloadinbtn(false);
          toast.success("Profile Updated Successfully");
          getdata();
        }
        Setloadinbtn(false);
      })
      .catch((error) => {
        Setloadinbtn(false);
      });
  };



  function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
    const words = text.split(" ");
    let line = "";
    for (let n = 0; n < words.length; n++) {
      const testLine = line + words[n] + " ";
      const metrics = ctx.measureText(testLine);
      const testWidth = metrics.width;
      if (testWidth > maxWidth && n > 0) {
        ctx.fillText(line, x, y);
        line = words[n] + " ";
        y += lineHeight;
      } else {
        line = testLine;
      }
    }
    ctx.fillText(line, x, y);
    return y + lineHeight; // return new Y position
  }

  const centers = [
    { "id": 61, "cname": "Aptech Defence" },
    { "id": 62, "cname": "Aptech F.B. Area" },
    { "id": 63, "cname": "Aptech Garden" },
    { "id": 64, "cname": "Aptech Clifton" },
    { "id": 65, "cname": "Aptech Gulistan-e-Johar" },
    { "id": 66, "cname": "Aptech Gulshan-e-Iqbal" },
    { "id": 67, "cname": "Aptech Landi" },
    { "id": 68, "cname": "Aptech North Karachi" },
    { "id": 69, "cname": "Aptech Metro Star Gate" },
    { "id": 70, "cname": "Aptech Korangi Road" },
    { "id": 71, "cname": "Aptech Mashrique Center" },
    { "id": 72, "cname": "Aptech I.I. Cundigar" },
    { "id": 73, "cname": "Aptech Shahrah-e-Faisal" },
    { "id": 74, "cname": "Aptech North Nazimabad" },
    { "id": 75, "cname": "Aptech SITE" },
    { "id": 76, "cname": "Aptech Surjani" },
    { "id": 77, "cname": "Aptech North Nazimabad 2" },
    { "id": 78, "cname": "Aptech Orangi Town" },
    { "id": 79, "cname": "Aptech Defence Hyderabad" },
    { "id": 80, "cname": "Aptech Jamshoro" },
    { "id": 81, "cname": "Aptech University Road" },
    { "id": 82, "cname": "Aptech Latifabad" },
    { "id": 83, "cname": "Aptech Tariq Road" },
    { "id": 84, "cname": "Aptech Sukkur" },
    { "id": 85, "cname": "Aptech Johar Town" },
    { "id": 86, "cname": "Aptech Faisalabad 2" },
    { "id": 87, "cname": "Aptech Cantt." },
    { "id": 88, "cname": "Aptech Larkana" },
    { "id": 89, "cname": "Aptech Gujranwala" },
    { "id": 90, "cname": "Aptech Timergara" },
    { "id": 91, "cname": "Aptech Rawalpindi" },
    { "id": 92, "cname": "Aptech Multan" },
    { "id": 93, "cname": "Aptech Sargodha" },
    { "id": 94, "cname": "Aptech Wah Cantt." },
    { "id": 96, "cname": "Aptech Gulshan-e-Maymar" },
    { "id": 97, "cname": "Aptech Metro Stargate" },
    { "id": 98, "cname": "Aptech Clifton" },
    { "id": 99, "cname": "Aptech TEST CENTER" },
    { "id": 100, "cname": "Aptech Demo" },
    { "id": 101, "cname": "Aptech Malir" },
    { "id": 102, "cname": "Aptech Baldia" },
    { "id": 103, "cname": "Aptech GMR" },
    { "id": 104, "cname": "Aptech Scheme" },
    { "id": 105, "cname": "Aptech Gulshan-e-Hadeed" }
  ]



  // const getPosters = async (members) => {
  //     setSaveStudentStates(members);

  //     // generate posters on selection
  //     const posters = await Promise.all(
  //       members.map(async (m) => {
  //         const file = await generateNameImage(m);
  //         return { student: m, file, url: URL.createObjectURL(file) };
  //       })
  //     );
  //     setPosterPreviews(posters);
  //   };

  async function generateNameImage(values, options = {}) {
    console.log(values);
    return new Promise((resolve, reject) => {
      // ✅ Check profile image before generating
      if (!values.std_profile_image || values.std_profile_image === "") {
        alert(`❌ Poster not generated - Profile image not found Please upload profile image to download poster.`);
        return reject(`No profile image for ${values.std_name}`);
      }

      const img = new Image();
      img.src = passTemplate1;

      img.onload = async () => {
        const targetWidth = 800;
        const targetHeight = Math.round((img.height / img.width) * targetWidth);

        const canvas = document.createElement("canvas");
        canvas.width = targetWidth;
        canvas.height = targetHeight;

        const ctx = canvas.getContext("2d");
        if (!ctx) return reject("Failed to get canvas context");

        ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

        // ✅ Draw profile image
        await new Promise((res, rej) => {
          const profileImg = new Image();
          //annonymous access to avoid CORS issues
          profileImg.crossOrigin = "anonymous";
          profileImg.src = PublicURLImages + 'users/' + values.std_profile_image;
          profileImg.onload = () => {
            const profileSize = 180;
            const profileX = 610;
            const profileY = 130;
            ctx.save();
            ctx.beginPath();
            ctx.arc(
              profileX + profileSize / 2,
              profileY + profileSize / 2,
              profileSize / 2,
              0,
              Math.PI * 2,
              true
            );
            ctx.closePath();
            ctx.clip();
            ctx.drawImage(profileImg, profileX, profileY, profileSize, profileSize);
            ctx.restore();
            res(true);
          };
          profileImg.onerror = rej;
        });

        // ✅ Text rendering
        ctx.fillStyle = options.color || "#ffffff";
        ctx.font = `bold ${options.fontSize || 28}px Helvetica`;
        ctx.textAlign = options.align || "left";

        ctx.fillText(values.std_name?.toUpperCase(), 360, 70);
        wrapText(ctx, `${centers
          .find(c => c.id === values.center_id)?.cname?.toUpperCase() || 'Unknown Center'

          }`, 360, 100, 400, 35);

        canvas.toBlob(
          (blob) => {
            if (!blob) return reject("Failed to create blob");
            downloadFile(new File([blob], "Poster.png", { type: "image/png" }), `${values.std_name}_Poster.png`);
          },
          "image/png",
          0.8
        );


        //download directly
        // canvas.toBlob(
        //   (blob) => {
        //     if (!blob) return reject("Failed to create blob");
        //     downloadFile(new File([blob], "Poster.png", { type: "image/png" }), `${values.std_name}_Poster.png`);
        //   },
        //   "image/png",
        //   0.8
        // );

      };
      img.onerror = reject;
    });
  }


  function downloadFile(file, filename) {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(file);
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }



  const handleDownloadPoster = (student) => {
    const {user_id } = student;
    service.post('addPosterDownloadCount', { user_id }).then((response) => {
      console.log(response);
      generateNameImage(student);
    }).catch((error) => {
      console.log(error);
    });

    // generateNameImage(student)
  }



  return (
    <div>
      <div className="maincontainer">
        <div>
          {!getstuddents.std_name == "" ? (
            <p
              style={{
                fontSize: 40,
                letterspacing: 2,
                fontWeight: "bold",
                color: "#AB509D",
                opacity: 0.8,
                paddingRight: "70%",
                marginBottom: 10,
              }}
            >
              {getstuddents.std_name}'s Profile
            </p>
          ) : (
            <p
              style={{
                fontSize: 40,
                letterspacing: 2,
                fontWeight: "bold",
                color: "#AB509D",
                opacity: 0.8,
                paddingRight: "70%",
                marginBottom: 10,
              }}
            >
              Your Profile
            </p>
          )}
        </div>
        <div className="grandContainer">
          <div>
            {!getstuddents.std_profile_image == "" ? (
              <>
                {isImageChange ? (
                  <>
                    <img
                      src={`data:image/jpeg;base64,${imagebase}`}
                      alt="preview image"
                      style={{
                        width: 200,
                        height: 200,
                        alignContent: "center",
                        alignItems: "center",
                        justifyContent: "center",
                        alignSelf: "center",
                        borderRadius: 100,
                      }}
                    />
                    <div className="innerGroup">
                      <p>Set Your Profile Picture</p>
                      <ColorButton
                        variant="contained"
                        component="label"
                        fullWidth
                      >
                        Select
                        <input
                          hidden
                          accept="image/*"
                          type="file"
                          onChange={onImageChange}
                        />
                      </ColorButton>
                    </div>
                  </>
                ) : (
                  <>
                    <img
                      src={`${PublicURLImages +
                        "users/" +
                        getstuddents.std_profile_image
                        }`}
                      alt="preview image"
                      style={{
                        width: 200,
                        height: 200,
                        alignContent: "center",
                        alignItems: "center",
                        justifyContent: "center",
                        alignSelf: "center",
                        borderRadius: 100,
                      }}
                    />
                    <div className="innerGroup">
                      <p>Set Your Profile Picture</p>
                      <ColorButton
                        variant="contained"
                        component="label"
                        fullWidth
                      >
                        Select
                        <input
                          hidden
                          accept="image/*"
                          type="file"
                          onChange={onImageChange}
                        />
                      </ColorButton>
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                {imagebase == "" ? (
                  <>
                    <AccountCircleIcon
                      onClick={() => {
                        // console.log("Profile");
                      }}
                      sx={{
                        color: "silver",
                        width: 200,
                        height: 200,
                        alignContent: "center",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: 100,
                        alignSelf: "center",
                      }}
                    />
                    <div className="innerGroup">
                      <p>Set Your Profile Picture</p>
                      <ColorButton
                        variant="contained"
                        component="label"
                        fullWidth
                      >
                        Select
                        <input
                          hidden
                          accept="image/*"
                          type="file"
                          onChange={onImageChange}
                        />
                      </ColorButton>
                    </div>
                  </>
                ) : (
                  <>
                    <img
                      src={`data:image/jpeg;base64,${imagebase}`}
                      alt="preview image"
                      style={{
                        width: 200,
                        height: 200,
                        alignContent: "center",
                        alignItems: "center",
                        justifyContent: "center",
                        alignSelf: "center",
                        borderRadius: 100,
                      }}
                    />
                    <div className="innerGroup">
                      <p>Set Your Profile Picture</p>
                      <ColorButton
                        variant="contained"
                        component="label"
                        fullWidth
                      >
                        Select
                        <input
                          hidden
                          accept="image/*"
                          type="file"
                          onChange={onImageChange}
                        />
                      </ColorButton>
                    </div>
                  </>
                )}
              </>
            )}
          </div>

          <div>
            <LoadingButton

              variant="outlined"

              sx={{
                backgroundColor: "#AB509D", color: "white", marginTop: 5, marginBottom: 5,
                borderColor: 'white'
                //hover
                , '&:hover': { backgroundColor: '#AB509D', borderColor: 'white' }

              }}
              onClick={() => {
                handleDownloadPoster(getstuddents)
              }}
            >
              Download My Exhibitor Poster
            </LoadingButton>
          </div>

          <div className="FormContainer">
            <div className="innerContainer">
              <form>
                <div className="innerGroup">
                  <p>Student Name</p>
                  <TextField
                    id="StudentName"
                    placeholder="Loading..."
                    name="name"
                    disabled={true}
                    onChange={formik.handleChange("name")}
                    value={formik.values?.name || ""}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                    margin="normal"
                    className="input"
                  />
                </div>
                <div className="innerGroup">
                  <p>Student ID</p>
                  <TextField
                    id="StudentID"
                    name="std_id"
                    placeholder="Loading..."
                    onChange={formik.handleChange("std_id")}
                    value={formik.values?.std_id}
                    error={
                      formik.touched.std_id && Boolean(formik.errors.std_id)
                    }
                    helperText={formik.touched.std_id && formik.errors.std_id}
                    disabled={true}
                    margin="normal"
                    className="input"
                  />
                </div>
                <div className="innerGroup">
                  <p>Student Email </p>
                  <TextField
                    id="StudentEmail"
                    name="email"
                    disabled={false}
                    onChange={formik.handleChange("email")}
                    value={formik.values.email}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                    margin="normal"
                    className="input"
                  />
                </div>
                <div className="innerGroup">
                  <p>Set Linkedin </p>
                  <TextField
                    id="SetPassword"
                    name="linkstd_linkedin_username"
                    type={"url"}
                    placeholder={"Provide Your Linkedin Url "}
                    label="Linkedin"
                    margin="normal"
                    className="input"
                    onChange={formik.handleChange("linkstd_linkedin_username")}
                    value={formik.values?.linkstd_linkedin_username || ""}
                    error={
                      formik.touched.linkstd_linkedin_username &&
                      Boolean(formik.errors.linkstd_linkedin_username)
                    }
                    helperText={
                      formik.touched.linkstd_linkedin_username &&
                      formik.errors.linkstd_linkedin_username
                    }
                  />
                </div>
                <p className="errorText">{newerror}</p>

                <LoadingButton
                  style={{ marginLeft: "20%" }}
                  loading={loadingbtn}
                  variant="outlined"
                  onClick={() => formik.handleSubmit()}
                  sx={{ backgroundColor: "#AB509D", color: "white" }}
                >
                  Update
                </LoadingButton>
              </form>
            </div>
          </div>
          {/* {responsestatus == 1 ? <ToastContainer /> : <></>} */}
          <ToastContainer />
        </div>
      </div>
    </div>
  );
};
